module.exports = __webpack_public_path__ + "img/ainicio.75bcc57c.jpg";